"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmarSolicitacaoNovaSenha = exports.validaSolicitacaoNovaSenha = exports.solicitarNovaSenha = exports.updatePeloAdm = exports.alterarSenhaRespAdm = exports.alterarSenhaResp = exports.update = void 0;
const core_1 = require("./core");
function update(data) {
    return core_1.post('Funcionario', 'alterarSenha', Object.assign({}, data));
}
exports.update = update;
function alterarSenhaResp(data) {
    return core_1.post('Contato', 'alterarSenha', Object.assign({}, data));
}
exports.alterarSenhaResp = alterarSenhaResp;
function alterarSenhaRespAdm(data) {
    return core_1.post('Contato', 'alterarSenhaPeloAdm', Object.assign({}, data));
}
exports.alterarSenhaRespAdm = alterarSenhaRespAdm;
function updatePeloAdm(data) {
    return core_1.post('Funcionario', 'alterarSenhaPeloAdm', Object.assign({}, data));
}
exports.updatePeloAdm = updatePeloAdm;
function solicitarNovaSenha(data) {
    return core_1.post('Acesso', 'solicitarNovaSenha', Object.assign({}, data));
}
exports.solicitarNovaSenha = solicitarNovaSenha;
function validaSolicitacaoNovaSenha(data) {
    return core_1.get('Acesso', 'validaSolicitacaoNovaSenha', Object.assign({}, data));
}
exports.validaSolicitacaoNovaSenha = validaSolicitacaoNovaSenha;
function confirmarSolicitacaoNovaSenha(data) {
    return core_1.post('Acesso', 'confirmaAlteracaoSenha', Object.assign({}, data));
}
exports.confirmarSolicitacaoNovaSenha = confirmarSolicitacaoNovaSenha;
